<template>
  <div v-if="addressLineOne.length > 3" id="cd-overview-address">
    <div>{{ addressLineOne }}</div>
    <div>{{ addressLineTwo }}</div>
  </div>
</template>

<script>
export default {
  props: {
    company: { type: Object, required: true },
  },
  computed: {
    addressLineOne() {
      const items = [this.company.line_one, this.company.line_two, this.company.city];
      return `${items.join(" ")},`;
    },
    addressLineTwo() {
      const items = [this.company.state.text, this.company.zip, this.company.country.text];
      return items.join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
#cd-overview-address {
  text-align: center;
}
</style>
